import React from 'react';
import ProfilePage from "./profile-page.jsx";
import ChangepasswordPage from "./change-password.jsx";
import ProfileSubscriptionCard from "./ProfileSubscriptionCard.jsx";
import "../../../styles/Auth/profilePassword.css";

const ProfileAndPasswordPage = () => {
    return (
        <div className="profile-page-container">
            <div className="profile-password-layout">
                <div className="profile-section1">
                    <ProfilePage />
                </div>
                <div className="password-section">
                    <ChangepasswordPage />
                </div>
            </div>
            <div className="profile-subscription-row">
                <ProfileSubscriptionCard />
            </div>
        </div>
    );
};

export default ProfileAndPasswordPage;